import * as go from 'gojs';
import { TEXT_NODE_TEXT_BLOCK } from '../config/common-part-names';

export const startTextEditing = (diagram: go.Diagram, textNode: go.Node): Promise<void> => {
  const textBlock = textNode.findObject(TEXT_NODE_TEXT_BLOCK);
  if (!(textBlock instanceof go.TextBlock)) {
    return Promise.resolve();
  }

  return new Promise((resolve) => {
    requestAnimationFrame(() => {
      diagram.commandHandler.editTextBlock(textBlock);
      resolve();
    });
  });
};
